import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import s from './AppDownload.css';
import shared from '../shared/landingShared.css';
import cs from '../../commonStyle.css';
import messages from '../../../locale/messages';
import { hasLandingAppLinks, LANDING_APP_LINKS } from '../landingContent';

import manApp from '../../../../images/new-landing/man.png';
import appStoreIcon from '../../../../images/new-landing/appstore.svg';
import googlePlayIcon from '../../../../images/new-landing/googleplay.svg';

class AppDownload extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  render() {
    const { intl } = this.props;
    const { appStoreUrl, playStoreUrl } = LANDING_APP_LINKS;
    const showStoreButtons = hasLandingAppLinks();

    return (
      <section className={s.appDownloadSection}>
        <div className={s.appDownloadText}>
          <span className={shared.overline}><FormattedMessage {...messages.newLandingGetTheApp} /></span>
          <h2><FormattedMessage {...messages.newLandingAppTitle} /></h2>
          <p><FormattedMessage {...messages.newLandingAppDescription} /></p>
          {showStoreButtons && (
            <div className={s.appDownloadStores}>
              {appStoreUrl && (
                <a href={appStoreUrl} target="_blank" rel="noreferrer" className={shared.storeBtn}>
                  <img src={appStoreIcon} alt="" aria-hidden="true" />
                  <div className={shared.storeText}><span>{intl.formatMessage(messages.newLandingAppStoreText)}</span><strong>{intl.formatMessage(messages.newLandingAppStoreLabel)}</strong></div>
                </a>
              )}
              {playStoreUrl && (
                <a href={playStoreUrl} target="_blank" rel="noreferrer" className={shared.storeBtn}>
                  <img src={googlePlayIcon} alt="" aria-hidden="true" />
                  <div className={shared.storeText}><span>{intl.formatMessage(messages.newLandingPlayStoreText)}</span><strong>{intl.formatMessage(messages.newLandingPlayStoreLabel)}</strong></div>
                </a>
              )}
            </div>
          )}
        </div>
        <div className={s.appDownloadImage}>
          <img src={manApp} alt={intl.formatMessage(messages.newLandingAppImageAlt)} />
        </div>
      </section>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s, shared, cs),
)(AppDownload);
